export const selectToasts = (state: RootState) => {
  return state.toasts.messages;
};
